import { Directive, HostListener } from '@angular/core';

import * as screenfull from 'screenfull';

@Directive({
  selector: '[appToggleFullscreen]'
})
export class ToggleFullscreenDirective {

  @HostListener('click') onClick() {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }
}



// WEBPACK FOOTER //
// /Users/clgingeniero/Documents/Proyectos/Impel/acertar/src/app/shared/fullscreen/toggle-fullscreen.directive.ts